// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"22":"chunk-[request][index]","245":"notfound"}[chunkId] + "." + {"22":"decb564c","245":"9ef7b6b5"}[chunkId] + ".js";
};